import { getFacturxApiBase } from "../../suiteSession";
import { printHtmlUrl } from "../../pdf/printSheet";

export function paymentPrintUrl(id: number, embed = false): string {
  return `${getFacturxApiBase()}/payment-print.php?id=${id}${embed ? "&embed=1" : ""}`;
}

export function printPaymentReceipt(id: number, fileTitle?: string): void {
  printHtmlUrl(paymentPrintUrl(id, true), undefined, fileTitle);
}
